// extracted by mini-css-extract-plugin
export default {"container":"RecipeComments_container__Km217","heading":"RecipeComments_heading__AltyF","no-comments":"RecipeComments_no-comments__ySGX3"};